import { type FC } from "react"

import { type BokaderoCourse } from "@forento/core/models/bokadero"
import { exhaustiveGuard } from "@forento/core/utilities/switch"
import { cn } from "@forento/ui/utilities/tailwind"

type Props = { status: BokaderoCourse["status"]; className?: string }
const CourseStatus: FC<Props> = ({ status, className }) => (
	<div
		className={cn(
			"flex items-center gap-2 self-start rounded-full border px-3 py-1 text-sm font-semibold",
			status === "draft"
				? "border-slate-200 bg-slate-100 text-slate-800"
				: status === "active"
					? "border-green-200 bg-green-100 text-green-800"
					: status === "submitted"
						? "border-yellow-200 bg-yellow-100 text-yellow-800"
						: status === "change-requested"
							? "border-orange-200 bg-orange-100 text-orange-800"
							: status === "rejected"
								? "border-red-200 bg-red-100 text-red-800"
								: exhaustiveGuard(status),
			className,
		)}
	>
		<div
			className={cn(
				"h-2 w-2 rounded-full",
				status === "draft"
					? "bg-slate-500"
					: status === "active"
						? "bg-green-500"
						: status === "submitted"
							? "bg-yellow-500"
							: status === "change-requested"
								? "bg-orange-500"
								: status === "rejected"
									? "bg-red-500"
									: exhaustiveGuard(status),
			)}
		/>
		{status === "draft"
			? "Utkast"
			: status === "active"
				? "Aktiv"
				: status === "submitted"
					? "Under granskning"
					: status === "change-requested"
						? "Ändringar begärda"
						: status === "rejected"
							? "Avvisad"
							: exhaustiveGuard(status)}
	</div>
)

export default CourseStatus
